// Vecchi URL rinominati per la SEO: i 301 li fa Nginx, questa mappa serve alla SPA
// se qualcuno arriva sul vecchio percorso senza passare dal server (link interni, cache).
export const LEGACY_TOUR_SLUGS = {
  amazzonia: "amazzonia-floresta-huni-kuin",
  Messico: "wirikuta-hikurito-sagrado-messico",
  "chapada-diamantina": "chapada-diamantina-raizes-da-bahia",
  Rwanda: "ruanda-gorilla-meraviglie-naturali",
};

export const LEGACY_LEADER_SLUGS = {
  "David-Urrea": "david-urrea",
  Maureen: "maureen",
  Quetzalli: "quetzalli",
  Sirio: "sirio",
  Valerio: "valerio",
};
